import * as z from "zod/mini";
/**
 * Monotonically increasing identifier for one protocol document generation.
 * Hosts use it to reject messages from replaced documents.
 */
export const generationSchema = z
    .number()
    .check(z.int(), z.minimum(0))
    .brand("Generation");
export function createGeneration(value) {
    const result = generationSchema.safeParse(value);
    if (!result.success) {
        throw new Error(`Invalid generation: ${value}`);
    }
    return result.data;
}
